<template>
  <div class="container mx-auto p-4">
    <h1 class="text-2xl font-bold mb-6">Client-Partner Relations Repair</h1>
    
    <div v-if="loading" class="text-center py-8">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
      <p class="mt-4">Executing repair script...</p>
    </div>
    
    <div v-else>
<button 
  @click="runRepairScript"
  :disabled="loading"
  class="relative flex items-center justify-center space-x-2 
         bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 
         text-white font-bold py-3 px-6 rounded-xl shadow-lg 
         transform transition-all duration-300 ease-in-out
         hover:shadow-xl hover:-translate-y-0.5
         focus:outline-none focus:ring-4 focus:ring-blue-500/50
         disabled:opacity-80 disabled:cursor-not-allowed"
>
  <!-- Icône de réparation -->
  <svg v-if="!loading" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
  </svg>
  
  <!-- Spinner pendant le chargement -->
  <svg v-else class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
  
  <span>{{ loading ? 'Repairing...' : 'Run Repair Script' }}</span>
  

  <span class="absolute inset-0 animate-ping bg-white opacity-0 rounded-full transition-all duration-1000" 
        :class="{'animate-ping opacity-20': isPulsing}"></span>
</button>
      
      <div v-if="results" class="bg-white shadow rounded-lg p-6">
        <h2 class="text-xl font-semibold mb-4">Execution Results</h2>
        
        <div class="grid grid-cols-2 gap-4 mb-6">
          <div class="bg-gray-50 p-4 rounded">
            <p class="text-gray-500">Profiles with referrals</p>
            <p class="text-2xl font-bold">{{ results.total_profiles }}</p>
          </div>
          
          <div class="bg-green-50 p-4 rounded">
            <p class="text-gray-500">Relations created</p>
            <p class="text-2xl font-bold text-green-600">{{ results.created }}</p>
          </div>
          
          <div class="bg-yellow-50 p-4 rounded">
            <p class="text-gray-500">Existing relations</p>
            <p class="text-2xl font-bold text-yellow-600">{{ results.skipped }}</p>
          </div>
          
          <div class="bg-red-50 p-4 rounded">
            <p class="text-gray-500">Invalid marketers</p>
            <p class="text-2xl font-bold text-red-600">{{ results.invalid_marketers }}</p>
          </div>
        </div>
        
        <h3 class="font-medium mb-2">Execution Log:</h3>
        <div class="bg-gray-900 text-gray-200 p-4 rounded font-mono text-sm max-h-96 overflow-y-auto">
          <div v-for="(line, index) in logs" :key="index" class="py-1 border-b border-gray-700 last:border-b-0">
            <span v-if="line.includes('✅')" class="text-green-400">✅</span>
            <span v-else-if="line.includes('⏩')" class="text-yellow-400">⏩</span>
            <span v-else-if="line.includes('⚠️')" class="text-red-400">⚠️</span>
            {{ line }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      results: null,
      logs: []
    };
  },
  methods: {
    async runRepairScript() {
      this.loading = true;
      this.results = null;
      this.logs = [];
      this.isPulsing = true
    

    setTimeout(() => {
      this.isPulsing = false
    }, 1000)
      
      try {
        const response = await axios.post('/api/v1/manager/repair-client-relations/');
        this.results = response.data.results;
        this.logs = response.data.logs;
      } catch (error) {
        console.error('Error executing script:', error);
        this.logs = ['❌ Error executing repair script'];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>